var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.title,"sub-title":_vm.subTitle}},[_c('b-card-text',[_vm._v("Customer: "+_vm._s(_vm.customer))]),_c('b-card-text',[_vm._v(_vm._s(_vm.description))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }